import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import {
  catchError,
  mergeMap,
} from 'rxjs/operators';
import { ModuleService } from '@core/services';
import { Modulo } from '@core/models';
import {
  MODULE_CREATE_VIEW,
  MODULE_EDIT_MODE,
  MODULE_FIND_ALL,
  MODULE_FIND_ALL_SUCCESS,
  MODULE_UPDATE_LOADING,
  MODULE_FAILURE,
  MODULE_UPDATE_VIEW,
  MODULE_UPDATE_ID,
  MODULE_FIND,
  MODULE_FIND_SUCCESS,
  SERVICE_FAILURE,
} from '@store/actions';

@Injectable()
export class ModuleEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private moduleService: ModuleService
  ) {}

  createView$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MODULE_CREATE_VIEW),
      mergeMap(() => [
        MODULE_EDIT_MODE({ editMode: true, isEditing: false }),
      ])
    )
  );

  updateView$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MODULE_UPDATE_VIEW),
      mergeMap(({ moduleId }) => [
        MODULE_UPDATE_ID({ moduleId }),
        MODULE_EDIT_MODE({ editMode: true, isEditing: true }),
      ])
    )
  );

  find$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MODULE_FIND),
      mergeMap(({ id }) => {
        this.store.dispatch(MODULE_UPDATE_LOADING({ loading: true }));
        return this.moduleService.find(id).pipe(
          mergeMap(({ data: module }) => {
            return [
              MODULE_FIND_SUCCESS({ module }),
              MODULE_UPDATE_LOADING({ loading: false }),
            ];
          }),
          catchError((error) =>
            of(
              SERVICE_FAILURE({ error }),
              MODULE_FAILURE({ error }),
              MODULE_UPDATE_LOADING({ loading: false })
            )
          )
        );
      })
    )
  );

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MODULE_FIND_ALL),
      mergeMap(() => {
        this.store.dispatch(MODULE_UPDATE_LOADING({ loading: true }));
        return this.moduleService.findAll().pipe(
          mergeMap(({ data }) => {
            const moduleList = data as Modulo[];
            return [
              MODULE_FIND_ALL_SUCCESS({ moduleList }),
              MODULE_UPDATE_LOADING({ loading: false }),
            ];
          }),
          catchError((error) =>
            of(
              SERVICE_FAILURE({ error }),
              MODULE_FAILURE({ error }),
              MODULE_UPDATE_LOADING({ loading: false })
            )
          )
        );
      })
    )
  );
}
